import useProfile from '../../../../hooks/providers/useProfile';
import Button from '../../../form/buttons/Button/Button';

const OnboardingNextStepButton = () => {
  const {goToNextVideo} = useProfile();

  return (
    <Button
      onClick={goToNextVideo}
      variant="contained"
      sx={{
        minWidth: 250,
        display: 'block',
        margin: '0 auto',
        fontSize: 13,
        mt: 3,
        mb: 1
      }}
      color="primary"
    >
      Etape suivante
    </Button>
  );
};

export default OnboardingNextStepButton;
